import React from 'react';
import { Code as LucideCode, LucideProps } from 'lucide-react';
import type { IconProps } from '../types';

export const Code = (props: LucideProps) => <LucideCode {...props} />;

export default Code;
